
const TituloBlog = ({ titulo, index }) => {
    return (
        <div style={{ maxWidth: "800px", margin: "0 auto", padding: "10px", fontSize: "1.1rem", color: "#333", marginBottom: "20px" }} >
            <h2 style={{ fontSize: "1.5rem" }}><span style={{ backgroundColor: "#1EFF86", width: "30px", height: "30px", display: "inline-block", textAlign: "center", lineHeight: "30px", borderRadius: "50%", color: "black", marginRight: "10px", fontSize: "1rem" }}>{index}</span> {titulo}</h2>
        </div>
    );
}

export default TituloBlog;